import { Flex, Form } from 'antd';
import { useCallback } from 'react';

import { MButton } from '@Components/Base';
import { FooterActions } from '@Enum/index';
import styles from './footer-button.module.css';

interface FooterButtonSectionProps {
  disabledSaveForm: boolean;
  disabledReview: boolean;
  onFooterAction: (action: FooterActions, payload?: string) => void;
  children?: JSX.Element | JSX.Element[];
}

const FooterButtonSection: React.FC<FooterButtonSectionProps> = ({
  disabledSaveForm,
  disabledReview,
  onFooterAction,
}) => {
  const onSaveAsDraft = useCallback(() => {
    onFooterAction(FooterActions.SAVE_AS_DRAFT);
  }, [onFooterAction]);

  const onReviewAndConfirm = useCallback(() => {
    onFooterAction(FooterActions.REVIEW_AND_CONFIRM);
  }, [onFooterAction]);

  return (
    <Flex vertical>
      <Flex className={styles.formButtons}>
        <Form.Item>
          <MButton
            type="secondary"
            onClick={onSaveAsDraft}
            disabled={!disabledSaveForm}
            className={styles.saveAsDraftButton}
          >
            Save As Draft
          </MButton>
        </Form.Item>
        <Form.Item>
          <MButton
            type="primary"
            onClick={onReviewAndConfirm}
            htmlType="submit"
            disabled={disabledReview}
          >
            Review & Confirm
          </MButton>
        </Form.Item>
      </Flex>
    </Flex>
  );
};

export default FooterButtonSection;
